import { h } from "preact";

import IconProps from "./IconProps";

function IconSketch({ width, height, class: cssClass }: Omit<IconProps, "color">) {
    return (
        <svg
            width={width}
            height={height}
            class={cssClass}
            fill="none"
            viewBox="0 0 58 52">
            <path fill="#EA6C00" fill-rule="evenodd" d="M11.785 18.684L28.94 51.94.106 18.684h11.679zM46.099 18.684L28.944 51.94l28.834-33.256H46.1z" clip-rule="evenodd"/>
            <path fill="#FDAD00" fill-rule="evenodd" d="M11.784 18.684h34.31L28.939 51.94 11.784 18.684z" clip-rule="evenodd"/>
            <path fill="#FDD231" fill-rule="evenodd" d="M28.939.254L12.687 1.955l-.903 16.73L28.94.253z" clip-rule="evenodd"/>
            <path fill="#FDD231" fill-rule="evenodd" d="M28.939.254l16.252 1.701.903 16.73L28.939.253z" clip-rule="evenodd"/>
            <path fill="#FDAD00" fill-rule="evenodd" d="M57.778 18.684L45.196 1.955l.903 16.73h11.68zM.106 18.684L12.688 1.955l-.903 16.73H.105z" clip-rule="evenodd"/>
            <path fill="#FEEEB7" fill-rule="evenodd" d="M28.939.254l-17.155 18.43h34.31L28.939.254z" clip-rule="evenodd"/>
        </svg>
    );
}

IconSketch.defaultProps = {
    width: 29,
    height: 26
};

export default IconSketch;
